import { MetricCard } from '@/components/MetricCard';
import type { AnomalySummary } from '../types';

interface ForecastSummaryCardsProps {
  summary: AnomalySummary | undefined;
  isLoading: boolean;
}

export default function ForecastSummaryCards({ summary, isLoading }: ForecastSummaryCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <MetricCard
        title="Total Anomalies"
        value={summary?.total ?? 0}
        loading={isLoading}
      />
      <MetricCard
        title="Critical"
        value={summary?.by_severity?.critical ?? 0}
        loading={isLoading}
        color="red"
      />
      <MetricCard
        title="Warning"
        value={summary?.by_severity?.warning ?? 0}
        loading={isLoading}
        color="orange"
      />
      <MetricCard
        title="Band Violations"
        value={summary?.by_type?.band_violation ?? 0}
        loading={isLoading}
        color="purple"
      />
    </div>
  );
}
